export const USERNAME_RECOVERY_POST = 'USERNAME_RECOVERY_POST'
export const USERNAME_RECOVERY_UPDATE = 'USERNAME_RECOVERY_UPDATE'
export const USERNAME_ERROR = 'USERNAME_ERROR'

export function postUsernameRecovery(payload = {}) {
  return {
    type: USERNAME_RECOVERY_POST,
    payload,
  }
}

export function updateUsernameRecovery(payload = {}) {
  return {
    type: USERNAME_RECOVERY_UPDATE,
    payload,
  }
}

export function errorUsername(payload = {}) {
  return {
    type: USERNAME_ERROR,
    payload,
  }
}
